<template>
  <div>
    <v-row no-gutters>
      <v-col cols="12" sm="12" md="4" lg="4" xl="4">
        <v-sheet
          color="grey lighten-4"
          :height="width>960 ?height :''"
        >
          <v-container class="pa-10">
            <font size=6 v-if="isBrowserJapanese">オープンソース :<br/>仮想通貨決済アプリ</font>
            <font size=6 v-else>Open Source Software: Crypto Pay App</font>

            <div class="my-10"/>
            <font size=2 v-if="isBrowserJapanese">
              パーミッションドブロックチェーンを利用したコミュニティ用決済アプリケーションです。<br/>
              フォームに登録すると、本アプリケーションレポジトリへの招待メールが送信されます。
            </font>
            <font size=3 v-else>
              This is a private-blockchain-based payment application for the community.<br/>
              Upon registration in the form, you will receive an email invitation to this application repository.
            </font>
          </v-container>
        </v-sheet>
      </v-col>

      <v-col cols="12" sm="12" md="6" lg="6" xl="6" offset-md="1" offset-lg="1" offset-xl="1">
        <v-container>
          <v-card
            class="mx-auto"
            elevation="0"
          >
            <v-card
              class="d-flex align-center justify-center mb-10 mt-3 pa-3"
              color="rgba(84,58,183,1)"
              dark
              elevation="0"
            >
              <font class="mx-auto" v-if="isBrowserJapanese">フォームを入力して、OSSのレポジトリへの招待を取得する。</font>
              <font class="mx-auto" v-else>Register to get access to OSS Repogitory</font>
            </v-card>

            <v-form
              lazy-validation
              ref="form"
              v-model="valid"
            >
              <v-text-field
                autofocus
                :label="labels.company"
                :rules="[rules.required]"
                v-model="form.company"
              ></v-text-field>
              <v-text-field
                :label="labels.job"
                :rules="[rules.required]"
                v-model="form.job"
              ></v-text-field>
              <v-text-field
                :label="labels.family"
                :rules="[rules.required]"
                v-model="form.family"
              ></v-text-field>
              <v-text-field
                :label="labels.first"
                :rules="[rules.required]"
                v-model="form.first"
              ></v-text-field>
              <v-text-field
                :label="labels.mail"
                :rules="[rules.required, rules.email]"
                v-model="form.mail"
              ></v-text-field>
              <v-text-field
                :label="labels.url"
                v-model="form.url"
              ></v-text-field>
            </v-form>

            <v-row
              align="center"
              justify="center"
              no-gutters
            >
              <v-card
                class="pa-1 mr-3 d-flex justify-center"
                color="red"
                dark
                rounded="pill"
                target="_blank"
                width="100" 
                :href="privatePolicyLink"
                @click="read = true"
              >
                <div v-if="isBrowserJapanese">重要</div>
                <div v-else>Essencial</div>
              </v-card>
              <a target="_blank" :href="privatePolicyLink" @click="read = true"> 
                <div v-if="isBrowserJapanese">個人情報の取扱いについて</div>
                <div v-else>Privacy Policy</div>
              </a>
            </v-row>

            <v-layout justify-center>
              <v-checkbox
                v-model="acception"
                :label="isBrowserJapanese
                ? '個人情報の取扱いに同意する'
                : 'I agree to terms and agreements of the privacy policy'
                "
              />
              
            </v-layout>

            <v-layout justify-center>
              <v-btn
                color="rgba(84,58,183,1)"
                :disabled="!acception"
                elevation="0"
                height="40"
                rounded
                width="400"
                @click="register"
              >
                <div v-if="isBrowserJapanese" style="color: white">
                  登録
                </div>
                <div v-else style="color: white">
                  register
                </div>
              </v-btn>
            </v-layout>

          </v-card>
        </v-container>
      </v-col>
    </v-row>
    <loading :loading="loading"/>
  </div>
</template>

<script>
import Firebase from '../util/firebase'
import Git from '../util/git'
import Loading from '../components/Loading.vue'
import router from '../router'

import windowSizeMixin from '../mixin/windowSizeMixin'
import isBrowserJapanese from '../mixin/isBrowserJapanese'

export default {
  mixins: [isBrowserJapanese, windowSizeMixin],
  components: {
    Loading,
  },
  computed: {
    labels: function(){
      if(this.isBrowserJapanese){
        return {
          company: '会社名*',
          job: '職業*',
          family: '姓*',
          first: '名*',
          mail: 'メールアドレス*',
          url: '会社HPのURL',
        };
      }
      return {
        company: 'Company Name*',
        job: 'Job*',
        family: 'Family Name*',
        first: 'First Name*',
        mail: 'E-mail address*',
        url: "The link for your company's website"
      };
    },
    privatePolicyLink: function(){
      if(this.isBrowserJapanese){
        return "http://www.micros.co.jp/privacy.html";
      }
      return "http://www.micros.co.jp/en/privacy.html";
    }
  },
  data: () => ({
    acception: false,
    read: false,
    loading: false,
    valid: true,
    form: {
      company: '',
      job: '',
      family: '',
      first: '',
      mail: '',
      url: '',
    },
    rules: {
      required: value => !!value || 'Required.',
      email: value => {
        const pattern = /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/
        return pattern.test(value) || 'Invalid e-mail.'
      },
    }
  }),
  methods: {
    register: async function(){
      if(this.$refs.form.validate()){
        this.loading = true;
        const firebase = new Firebase();
        const git = new Git();
        await Promise.all([
          firebase.addDocument(this.form),
          git.inviteUser(this.form.mail),
        ]);
        this.loading = false;
        router.push({name: 'Done', query: {mail: this.form.mail}});
      }
    }
  }
};
</script>